/*
 * What kind of pointer is reading this (D-10 D14, VISUAL.md §7.6).
 *
 * A device with no hovering pointer is a device with no Shift key worth using and no tooltip worth
 * drawing: there, Enter starts a new line and the visible send button is what sends, so the hint
 * that names the send key is neither drawn nor true. Both halves of that — the keymap's and the
 * frame's — read the same question here rather than asking `matchMedia` twice with two spellings.
 *
 * It is read at the moment it is needed and not subscribed to: a pointer type does not change under
 * a person's hands, and a composer that re-rendered on a media change would have to decide what
 * happens to a half-typed line.
 */

/** True where the pointer cannot hover: a phone, a tablet, a touch screen without a mouse. */
export function noHoverPointer(): boolean {
	return typeof matchMedia === "function" && matchMedia("(hover: none)").matches
}

/**
 * True where the pointer is a blunt one: a finger or a stylus, whether or not a mouse is plugged in
 * beside it. This is the question a *target size* asks — a thumb is no more accurate on a tablet
 * with a trackpad than on a phone — and it is the one `(pointer: coarse)` in a stylesheet asks, so a
 * layout whose numbers are split between CSS and a component reads the same side of it here.
 */
export function coarsePointer(): boolean {
	return typeof matchMedia === "function" && matchMedia("(pointer: coarse)").matches
}
